export default __webpack_public_path__ + "static/precedent-logo-511db81c89480693ed234078d2cfb7c7.png";